module.exports = __webpack_public_path__ + "static/media/calefont1.057be468.png";